import { IDarkModeRepository, ResponseValueObject } from '@gishub/domain';

export class DarkModeRepository implements IDarkModeRepository {
  private readonly storageKey = 'ghp_darkMode';

  async load(): Promise<ResponseValueObject<boolean>> {
    const item = localStorage.getItem(this.storageKey);
    const isDark = item === 'true';
    return new ResponseValueObject(true, isDark);
  }

  async save(isDark: boolean): Promise<ResponseValueObject<void>> {
    localStorage.setItem(this.storageKey, isDark ? 'true' : 'false');
    return new ResponseValueObject(true, undefined);
  }
}
